import React from 'react';

interface OverallPerformanceSummaryProps {
  typingScore: number; // 総合ロボット完成度からタイピングスコアに変更
  overallEvaluationComment: string;
  totalPlayTime: string;
  onGoToTitle: () => void;
}

const OverallPerformanceSummary: React.FC<OverallPerformanceSummaryProps> = ({
  typingScore, // プロパティ名を変更
  overallEvaluationComment,
  totalPlayTime,
  onGoToTitle,
}) => {
  return (
    <div className="overall-performance-summary bg-gradient-to-br from-slate-100 to-sky-100 p-4 sm:p-8 rounded-xl shadow-2xl max-w-3xl mx-auto my-8">
      <h1 className="text-3xl sm:text-4xl font-extrabold text-center text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-sky-400 mb-8">
        総合パフォーマンスサマリ
      </h1>

      <section className="bg-white p-6 rounded-lg shadow-lg mb-6">
        <h2 className="text-2xl font-bold text-blue-700 mb-3">タイピング総合スコア</h2>
        {/* テキストを変更 */}
        <p className="text-5xl font-bold text-green-500 text-center py-4">
          {typingScore}
          {/* プロパティ名を変更 */}
        </p>
        {/* ここにロボットのビジュアルなどを表示することも検討 */}
      </section>

      <section className="bg-white p-6 rounded-lg shadow-lg mb-6">
        <h2 className="text-2xl font-bold text-blue-700 mb-3">総合評価コメント</h2>
        <p className="text-gray-700 italic bg-green-50 p-4 rounded-md border border-green-200">
          {overallEvaluationComment}
        </p>
      </section>

      <section className="bg-white p-6 rounded-lg shadow-lg">
        <h2 className="text-2xl font-bold text-blue-700 mb-3">総プレイ時間</h2>
        <p className="text-3xl font-bold text-purple-600 text-center py-3">{totalPlayTime}</p>
      </section>

      {/* TOPへ戻るボタンを追加 */}
      <div className="mt-8 text-center">
        <button
          onClick={onGoToTitle}
          className="px-8 py-3 bg-blue-600 text-white font-bold rounded-lg shadow-md hover:bg-blue-700 transition-transform transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
        >
          TOPへ戻る
        </button>
      </div>

      {/* 必要に応じて記念撮影モードなどのボタンを配置 */}
      {/* 例:
      <div className="mt-8 text-center">
        <button className="px-6 py-3 bg-pink-500 text-white font-bold rounded-lg shadow-md hover:bg-pink-600 transition-transform transform hover:scale-105">
          記念撮影をする！
        </button>
      </div>
      */}
    </div>
  );
};

export default OverallPerformanceSummary;
